import { Autocomplete, Box, Button, Card, Checkbox, Chip, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, set, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { BrandContext } from '.';
import ImgUploadDialog from '../../components/ImgUpload/imgUpload';
import { Helpers } from '../../services/Helpers';
import { AddToPhotos, CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { BrandServices } from './BrandServices';
import { PermissionGuard } from '../../components/PermissionGuard';
// import { PermissionGuard } from '../../../../components/PermissionGuard';
// import UnauthorizedPage from '../../../UnAuthorized';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

const AddEditBrand = () => {
    const { brandInitialData,brandData,setBrandData,fetchBrandList,brandList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedBrandData, setSelectedBrandData} = useContext(BrandContext)
    const [pageTitle, setPageTitle] = useState('Add Brand');
    const {control,handleSubmit,formState:{errors,isDirty},reset,watch,setValue,clearErrors} = useForm({
        mode:'onChange',
        defaultValues:brandData,
    });
    const [isSubmitted,setIsSubmitted] = useState(false);
    const resetForm = () => {
    // Reset form to initial values
    reset(brandInitialData, { keepDirty: false });
    
    // Clear all state arrays
    setSelectedServices([]);
    setImageUploadResponseDetails({});
    setSubCategoryList([]);
    setServiceList([]);    
    // Clear context data
    setSelectedBrandData(null);
    setBrandData(brandInitialData);
}

    const onSubmit = async (data)=>{
        const result = await Swal.fire({
            title: 'are you sure?',
            text: `Do you want to ${selectedBrandData?'update':'save'} this data?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Yes, ${selectedBrandData?'update':'save'}`,
            cancelButtonText: 'No, cancel',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCloseButton: false,
        });
        if(result.isConfirmed){
            Swal.fire({
                title: `Please wait...`,
                text:   `while we ${selectedBrandData?'updating':'saving'} your data `,
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            // setIsSubmitted(true);
            console.log("data:",data);
            const ModifiedData = {
                title:data.title,
                image:data.image,
                bLevel:data.bLevel,
                isActive:data.isActive,
                serviceIds:selectedServices.map(s=>s.masterServiceId)
            }
            try{
                if(selectedBrandData){
                    //update
                    const updateresponse = await BrandServices.updateBrand(ModifiedData,selectedBrandData.id);
                    if(updateresponse.success == '1'){
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Data updated successfully',
                            timer:1000
                        })
                        fetchBrandList();
                        resetForm();
                    }else if(updateresponse.success == '0'){                    
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: updateresponse.message || 'failed to update data',
                        })
                    }
                }else{
                    //save
                    const saveresponse = await BrandServices.addBrand(ModifiedData);
                    if(saveresponse.success == '1'){
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Data saved successfully',
                            timer:1000
                        })
                        fetchBrandList();
                        resetForm();
                    }else if(saveresponse.success == '0'){
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: saveresponse.message || 'failed to save data',
                        })
                    }
                }
            }catch (error){
                console.log("error:",error)
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'failed to save data...Something went wrong!',
                })
            }
        }
        
    }
    useEffect(()=>{
        if(selectedBrandData){
            setPageTitle('Edit Brand');
            const modifiedData = {
                ...selectedBrandData,
            }

            setBrandData(modifiedData);
            console.log("selectedBrandData:",selectedBrandData);
            if(selectedBrandData?.bSer && selectedBrandData?.bSer.length > 0){
            // filter and return masterServiceId and title only
                const selectedServs = selectedBrandData.bSer.map(s=>({
                    masterServiceId:s.masterServiceId,
                    title:s?.sDetail?.title
                }))
                const selectedServiceIds = selectedServs.map(s=>s.masterServiceId);
                console.log("selectedServs:",selectedServs);
                setValue('serviceIds',selectedServiceIds);
                modifiedData.serviceIds = selectedServiceIds;
                setSelectedServices(selectedServs);
            }
            reset(modifiedData,{isDirty:false});
        }else{
            setPageTitle('Add Brand');
        }
    },[selectedBrandData])

    /*================== image upload realted ====================== */
    const [imageUploadResponseDetails, setImageUploadResponseDetails] = useState({});
    const [imgModalOpen, setImgModalOpen] = useState(false);

    const openImgModal = () => {
        setImgModalOpen(true);
    };

    const closeModal = () => {
        setImgModalOpen(false);
    };

    const imgData = {
        path: 'brands',
        img_type: "single"
    };
    const imgUploadResponse = (data) => {
        setImageUploadResponseDetails(data);
        setValue('image', data.imageName, { shouldDirty: true, shouldValidate: true });
    }

    const [categoryList, setCategoryList] = useState([]);
    const fetchCategoryList= async()=>{
        try {
            const categoryListResponse = await BrandServices.categoryList();
            // console.log("category list Response:",categoryListResponse);
            if(categoryListResponse.success===1){
            setCategoryList(categoryListResponse.data)
            }
        } catch (error) {
            
        }
    }
    const categoryId = watch('categoryId');
    const [subCategoryList, setSubCategoryList] = useState([]);
    const fetchSubCategoryList= async()=>{
        try {
        const subCategoryListResponse = await BrandServices.subCategoryList({categoryId:categoryId});
        // console.log("sub category list Response:",subCategoryListResponse);
        if(subCategoryListResponse.success===1){
            setSubCategoryList(subCategoryListResponse.data)
        }
        } catch (error) {
        
        }finally{
        setIsSubmitted(false);
        }
    }
    const subCategoryId = watch('subCategoryId');
    const [serviceList, setServiceList] = useState([]);

    const [selectedServices, setSelectedServices] = useState([]);
    const fetchServiceList= async()=>{
        try {
        const serviceListResponse = await BrandServices.serviceList({subCategoryId:subCategoryId});
        // console.log("service list Response:",serviceListResponse);
        if(serviceListResponse.success===1){
            setServiceList(serviceListResponse.data)
        }
        } catch (error) {
        
        }finally{
        setIsSubmitted(false);
        }
    }
    const handleDelete = (masterServiceId) => {
        setSelectedServices((prevSelectedServices) =>
          prevSelectedServices.filter((service) => service.masterServiceId !== masterServiceId)
        );
        const updatedServiceIds = selectedServices
          .filter((service) => service.masterServiceId !== masterServiceId)
          .map((service) => service.masterServiceId);
        setValue('serviceIds', updatedServiceIds, { shouldDirty: true, shouldValidate: true });
        // setValue('services', selectedServices.filter((service) => service.masterServiceId !== masterServiceId), { shouldDirty: true, shouldValidate: true });
    }
    useEffect(()=>{
        fetchCategoryList();
    },[])
    useEffect(()=>{
        if(categoryId && categoryId != '0'){
            setValue('subCategoryId','',{shouldDirty:true});
            setSubCategoryList([]);
            setValue('services','',{shouldDirty:true});
            setServiceList([]);
            fetchSubCategoryList();
        }
        else{
            setValue('subCategoryId','',{shouldDirty:true});
            setSubCategoryList([]);
            setValue('services','',{shouldDirty:true});
            setServiceList([]);
            
        }
    },[categoryId])
    
    useEffect(()=>{
        if(subCategoryId && subCategoryId != '0'){
            setValue('services','',{shouldDirty:true});
            setServiceList([]);
            fetchServiceList();
        }
    },[subCategoryId])
    
    const handleServiceSelection = (newValue) => {
        console.log("newValue", newValue);
        
        // Get services from current serviceList (current category/subcategory)
        const currentCategoryServiceIds = serviceList.map(s => s.masterServiceId);
        
        // Keep services from other categories that are not in current serviceList
        const servicesFromOtherCategories = selectedServices.filter(
            service => !currentCategoryServiceIds.includes(service.masterServiceId)
        );
        
        // Combine services from other categories with newly selected services from current category
        const updatedSelectedServices = [...servicesFromOtherCategories, ...newValue];

        // seleected serviceIds
        const selectedServiceIds = updatedSelectedServices.map(s => s.masterServiceId);        
        setSelectedServices(updatedSelectedServices);
        setValue('serviceIds', selectedServiceIds, { shouldDirty: true, shouldValidate: true });
        setValue('services', newValue, { shouldDirty: true, shouldValidate: true });

        if (updatedSelectedServices.length > 0) {
            clearErrors('services');
        }
    }
    
    const getServices = () => {
        return serviceList.filter(service => 
            selectedServices.some(selected => selected.masterServiceId === service.masterServiceId)
        );
    }
  return (
    <Card>
        <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
            <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >{pageTitle}</Typography>
        </Box>
        <Box component={'form'} onSubmit={handleSubmit(onSubmit)} sx={{p:1}}>                
            <Grid container spacing={2}>                    
                <Grid item xs={12}>
                    <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Title <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                    <Controller
                        name='title'
                        control={control}
                        rules={{
                            required:'title required',
                        }}
                        render={({field,fieldState:{error}})=>
                            <TextField
                                {...field}
                                size='small'
                                fullWidth
                                // type='number'
                                error={!!error}
                                inputProps={{
                                    style:{
                                        fontSize:'0.65rem'
                                    },
                                }}
                            />
                        }
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>
                                Service Image <Box component="span" sx={{ color: 'error.main' }}>*</Box>
                            </Typography>

                            <Box sx={{ textAlign: 'center'}}>
                                <Box sx={{height: '11rem',border:'1px dashed gray',borderRadius:'4px',mb:1}}>

                                
                                    {(imageUploadResponseDetails.imageName || brandData.image) && (
                                        <Box sx={{ mb: 2, justifyContent: 'center', boxShadow: '0 0 5px rgba(0,0,0,0.1)' ,height:'100%',display:'flex',alignItems:'center'}}>
                                            <img
                                                src={`${Helpers.ImagePathUrl()}/brands/md/${imageUploadResponseDetails.imageName || brandData.image}`}
                                                alt="Service"
                                                style={{ maxWidth: '100%' ,maxHeight:'100%' }}
                                            />
                                        </Box>
                                    )}
                                </Box>

                                <Button
                                    onClick={openImgModal}
                                    // disabled={isSubmitting}
                                    variant="outlined"
                                    startIcon={<AddToPhotos />}
                                    size="small"
                                    fullWidth
                                >
                                    {imageUploadResponseDetails.imageName || brandData.image ? 'Change Image' : 'Select Image'}
                                </Button>
                            </Box>

                            <Controller
                                control={control}
                                name='image'
                                rules={{ required: 'Please upload an image' }}
                                render={({ fieldState: { error } }) => (
                                    error && (
                                        <Typography color="error" variant="caption" display="block" textAlign="center">
                                            {error.message}
                                        </Typography>
                                    )
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Brand Level <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                            <Controller
                                control={control}
                                name="bLevel"
                                rules={{
                                    required:'select Brand Level',
                                }}
                                render={({field,fieldState:{error}})=>(
                                    <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                        <Select
                                            {...field}
                                            error={!!error}
                                            sx={{
                                                fontSize:'0.65rem',
                                            }}
                                        >
                                            {/* 'ultrapremium', 'premium', 'midtier', 'value', 'low' */}
                                            <MenuItem value='ultrapremium' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Ultrapremium</MenuItem>
                                            <MenuItem value='premium' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Premium</MenuItem>
                                            <MenuItem value='midtier' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Midtier</MenuItem>
                                            <MenuItem value='value' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Value</MenuItem>
                                            <MenuItem value='low' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Low</MenuItem>
                                        </Select>
                                    </FormControl>
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{fontWeight:600,fontSize:'0.75rem'}}>Category </Typography>
                            <Controller
                                name='categoryId'
                                control={control}
                                // rules={{required:'select category'}}
                                render={({field,fieldState:{error}})=>(
                                    <FormControl size='small' sx={{ minWidth: "100%" }}>
                                        <Select
                                            {...field}
                                            onChange={(e) => {
                                                const selectedValue = e.target.value;                                                
                                                field.onChange(selectedValue);
                                            }}
                                            sx={{
                                                // minHeight: '0px',
                                                // height: '1.6rem',
                                                fontSize: '0.75rem',
                                                '& .MuiSelect-select': {
                                                // padding: '0 8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                },
                                            }}
                                            error={!!error}
                                            // helperText={error && error?.message}
                                        >
                                        { categoryList &&
                                            categoryList.map((category,index)=>(
                                            <MenuItem sx={{fontSize:'0.75rem'}} value={category.id} key={index}>{category.title}</MenuItem>
                                            ))

                                        }
                                        </Select>
                                    </FormControl>
                                )}  
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{fontWeight:600,fontSize:'0.75rem'}}>Sub Category </Typography>
                            <Controller
                                name='subCategoryId'
                                control={control}
                                // rules={{required:'select sub-category'}}
                                render={({field,fieldState:{error}})=>(
                                    <FormControl size='small' sx={{ minWidth: "100%" }}>
                                    {/* <InputLabel id="">Select Gender</InputLabel> */}
                                        <Select
                                            {...field}
                                            disabled={ categoryId == '0' || !categoryId}
                                            // label="Select Gender"
                                            sx={{
                                                // minHeight: '0px',
                                                // height: '1.6rem',
                                                fontSize: '0.75rem',
                                                '& .MuiSelect-select': {
                                                // padding: '0 8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                },
                                            }}
                                            error={!!error}
                                            // helperText={error && error?.message}
                                        >
                                        {subCategoryList &&
                                            subCategoryList.map((subCategory,scIndex)=>(
                                            <MenuItem sx={{fontSize:'0.75rem'}} value={subCategory.id} key={scIndex}>{subCategory.title}</MenuItem>
                                            ))
                                        }
                                        </Select>
                                    </FormControl>
                                )}  
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{fontSize:'0.75rem', fontWeight: 600 }}>Services</Typography>
                            <Controller
                                name='services'
                                control={control}
                                rules={{}}
                                render={({ field }) => (
                                <Autocomplete
                                    {...field}
                                    sx={{
                                    '& .MuiAutocomplete-input': {
                                        fontSize: '0.75rem',
                                    },
                                    }}
                                    disabled={!serviceList.length>0}
                                    multiple
                                    disableCloseOnSelect
                                    options={serviceList}
                                    // options={serviceList.filter(service => !isServiceAlreadySelected(service.masterServiceId))}
                                    getOptionLabel={(option) => option.title}
                                    renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ 
                                            marginRight: 8,
                                            transform: 'scale(0.8)',
                                        }}
                                        checked={selected}
                                        />
                                        <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                                        {option.title}
                                        </Typography>
                                    </li>
                                    )}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size='small'
                                        variant="outlined"
                                        placeholder="Select services"
                                    />
                                    )}
                                    onChange={(_, newValue) => {
                                    handleServiceSelection(newValue);
                                    }}
                                    isOptionEqualToValue={(option, value) => option.masterServiceId === value.masterServiceId}
                                    value={getServices()}
                                    renderTags={()=>null}
                                />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {selectedServices.length > 0 &&<Grid item xs={12}>
                    <Typography sx={{fontSize:'0.75rem', fontWeight: 600 }}>Associated Services</Typography>
                    <Box  sx={{border:'1px dashed lightGray',p:1,display:'flex',flexWrap:'wrap',minHeight:'2rem',alignItems:'center',gap:1,overflowY:'auto'}}>
                        {selectedServices.length > 0 && selectedServices.map((service,index)=>(
                            <Chip label={service.title} size='small' sx={{fontSize:'0.65rem'}} onDelete={()=>handleDelete(service.masterServiceId)}
                                key={index}
                            />
                        ))}
                    </Box>
                </Grid>}
                
                <Grid item xs={12} sx={{display:'flex',justifyContent:'center',gap:2}}>
                    <Button 
                        variant='contained' 
                        size='small' 
                        color='error'
                        onClick={resetForm}
                        disabled={selectedBrandData?false:!isDirty}
                    >
                        Cancel
                    </Button>
                    <PermissionGuard feature={'brand'} permission='canCreate'>
                        {!selectedBrandData && <Button 
                            variant='contained' 
                            size='small' 
                            type='submit'
                            disabled={!isDirty}
                        >
                            Save
                        </Button>}
                    </PermissionGuard>
                    <PermissionGuard feature={'brand'} permission='canEdit'>
                        {selectedBrandData && <Button 
                            variant='contained' 
                            size='small' 
                            type='submit'
                            disabled={!isDirty}
                        >
                            Update
                        </Button>}
                    </PermissionGuard>                        
                </Grid>
            </Grid>                              
        </Box>
        {/* ============== image upload dialog ============= */}
        <ImgUploadDialog open={imgModalOpen} onClose={closeModal}
            imgData={imgData}
            imgUploadResponse={imgUploadResponse}
        />
    </Card>
  );
}

export default AddEditBrand;
const formatValue = (value) => {
    if (typeof value !== 'string') {
      return value === 0 ? 0 : value?.toString() || '';
    }
    const formatted = value.replace(/^0+(?=\d)/, '').replace(/^\./, '0.');
    return formatted === '' ? '' : formatted;
};